module.exports = __webpack_public_path__ + "static/image/main/m/banner-6-1.ver2_0_2.jpg?0774c413";